import { useLocation, useNavigate } from "react-router-dom";
import { SalaryDeviationConstants } from "utils/constants";
import { DateHelper, UrlHelper } from "utils/helpers";

function useOnViewSalaryDraftDeviation(yearMonth: number) {
  const location = useLocation();
  const navigate = useNavigate();

  const onDeviationClick = () => {
    const deviationMonth = DateHelper.getYearMonth(DateHelper.addMonths(DateHelper.getDateFromYearMonth(yearMonth), -1));

    navigate(UrlHelper.formatPath(`/Employees/Deviations`), {
      state: {
        background: location,
        [SalaryDeviationConstants.SalaryDeviationYearMonthKey]: deviationMonth,
      },
    });
  };

  return onDeviationClick;
}

export default useOnViewSalaryDraftDeviation;
